import { connect } from 'react-redux';
import { getActiveProgram } from 'dux/router/selectors';
import { progress, client, translations } from '@biw/contests-core';
import LevelComparisonTable from './level-comparison-table';
import { ProgramModel } from '@biw/contests-core/lib/dux/programs';

const EMPTY_OBJ = {};

export const mapStateToProps = ( state: any ) => {
    const program = getActiveProgram( state ) || EMPTY_OBJ as ProgramModel;
    const goal = progress.selectors.getProgramViewGoal( state, program.programViewId ) || EMPTY_OBJ;
    return {
        program,
        locale: translations.selectors.getUserLocale( state ),
        mediaLabel: client.selectors.getMediaLabel( state ),
        goalLevels: goal.goalLevels,
        goalLabel: goal.goalLabel,
        baseValue: goal.baseValue,
        mqLabel: goal.mqLabel,
        isBaseLineRequired: goal.isBaseLineRequired,
        bonusPayout: goal.bonusPayout,
        calculationLabel: goal.calculationLabel,
    };
};

export default connect( mapStateToProps )( LevelComparisonTable );
